/**
 * The $TISM mark: a single infinity loop in the accent colour. The infinity
 * loop is the neurodiversity symbol and, in gold, the autistic-pride mark;
 * red is both the indexsy accent and the community's #RedInstead. One shape
 * serves the favicon, the header, the token image and the social card.
 */
export function Mark({ size = 26, color = "currentColor" }: { size?: number; color?: string }) {
  return (
    <svg
      className="mark"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M32,32 C32,22 50,22 50,32 C50,42 32,42 32,32 C32,22 14,22 14,32 C14,42 32,42 32,32"
        fill="none"
        stroke={color}
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
